const { pixelToDxa } = require('@/libs/utils/docxUtils')

const tableWidthDxa = pixelToDxa(1030)
const tableIndentedWidthDxa = pixelToDxa(1000)
const tableWidthDxa1050 = pixelToDxa(1050)
const tableWidthDxa1150 = pixelToDxa(1150)

export { tableWidthDxa, tableIndentedWidthDxa, tableWidthDxa1050, tableWidthDxa1150 }
